/**
 * İLK AÇILIŞ DİLİ IP coğrafiyasına görə (BR 26.4) — yalnız dil hələ saxlanmayıbsa.
 *
 * ⚠ NİYƏ (2026-10-02 auditi): veb TV həmişə «az» ilə açılırdı; sayt isə IP ölkəsinə görə
 *   seçir (AZ→az, RU→ru, TR→tr, DE/AT/CH→de, qalan→en). Xəritə serverdədir
 *   (`GET /api/geo/language`) — iki yerdə ayrı saxlanmır (iOS və Android eyni ucu çağırır).
 * ⚠ NİYƏ BOOT SORĞULARINDAN ƏVVƏL: ana səhifə, tövsiyə və siyahı sorğuları `lang=` ilə
 *   gedir — dil sonradan dəyişsəydi hamısı ikinci dəfə çəkilərdi. Gecikmə YALNIZ ilk
 *   açılışdadır (saxlanc boşdur) və ən çox `GEO_TIMEOUT_MS`-dir; sonrakı açılışlarda promise
 *   dərhal həll olunur.
 * ⚠ HEÇ VAXT REJECT ETMİR: köhnə server (404), şəbəkə yoxdur, vaxt bitdi — hamısında defolt
 *   dil qalır və heç nə yazılmır (növbəti açılışda yenidən soruşulur).
 * ⚠ ES2015 həddi (PERFORMANCE.md): async/await yoxdur, promise zənciri.
 */
import { httpJson, withTimeout } from '@/lib/compat'
import { hasStoredLanguage, LANGUAGES, rememberLanguage } from '@/lib/language'

const GEO_TIMEOUT_MS = 1500

interface GeoLanguage {
  country: string | null
  language: string
}

export function resolveFirstLaunchLanguage(): Promise<void> {
  if (hasStoredLanguage()) return Promise.resolve()
  return withTimeout(httpJson<GeoLanguage>('/api/geo/language'), GEO_TIMEOUT_MS, 'geo/language')
    .then((geo) => {
      const code = geo ? geo.language : ''
      for (let i = 0; i < LANGUAGES.length; i++) {
        if ((LANGUAGES[i] as { code: string }).code === code) {
          rememberLanguage(code)
          return
        }
      }
    })
    .catch(() => {
      // Defolt dil qalır — izah faylın başındadır.
    })
}
